import React, {useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import BizLocationSelector from '../../../../component/BizLocation/BizLocationSelector'
import BizStepSelector from '../../../../component/BizStep/BizStepSelector'

import {InputWithLabel} from '../../../../component/Form/InputWithLabel'
import DispositionSelector from '../../../../disposition/DispositionSelector'
import ProductTypeSelector, {mapItems} from '../../../../productType/component/ProductTypeSelector'

function PermanenceAlertForm({defaultValue = {}, setValue}) {

  const [duration, setDuration] = useState({
    days: Math.floor(defaultValue.durationInHours / 24 || 0),
    hours: (defaultValue.durationInHours % 24 || 0)
  })

  return (
    <Row>
      <Col md={3}>
        <BizLocationSelector
          setValue={e => setValue({
            bizLocations: e
          })}
          multiple
          defaultValue={defaultValue.bizLocations}
        />
      </Col>
      <Col md={3}>
        <ProductTypeSelector
          setValue={e => {
            setValue({
              productTypes: e
            })
          }}
          multiple
          defaultValue={defaultValue.productTypes && defaultValue.productTypes.map(mapItems)}
        />
      </Col>
      <Col md={3}>
        <BizStepSelector
          setValue={e => setValue({
            bizSteps: e
          })}
          multiple
          defaultValue={defaultValue.bizSteps}
        />
      </Col>
      <Col md={3}>
        <DispositionSelector
          setValue={e => setValue({dispositions: e})}
          multiple
          defaultValue={defaultValue.dispositions}
        />
      </Col>
      <Col md={3}>
        <InputWithLabel
          label="Dias"
          inputType="number"
          onChange={(e) => {
            setDuration({...duration, days: e.target.value})
            const total = e.target.value * 24
            setValue({durationInHours: (total + duration.hours)})
          }}
          value={duration.days || 0}
        />
        <InputWithLabel
          label="Horas"
          max={23}
          inputType="number"
          onChange={(e) => {
            setDuration({...duration, hours: e.target.value})
            setValue({durationInHours: (Number(e.target.value) + (duration.days * 24))})
          }}
          value={duration.hours || 0}
        />
      </Col>
    </Row>
  )
}

export {PermanenceAlertForm}



// WEBPACK FOOTER //
// ./src/pages/Alerts/CustomAlert/PermanenceAlert/PermancenceAlertForm.js